<template>
  <div class="card shadow m-3 position-fixed right-0 top-0" style="z-index: 1">
    <div style="width: 456px" class="card-body d-flex align-items-center">
      <div
        :class="{ rotate: !complete }"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
        style="width: 50px; height: 50px"
        data-test="progress-bar"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>

      <div style="width: 80%">
        <div class="progress rounded-round mb-2" style="height: 12px">
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          />
        </div>
        <div>
          {{ $t('Creating Product & Inventory List') }}
        </div>

        <div v-if="showLogError">
          <a
            href="#collapse-icon"
            class="collapsed font-size-sm text-default"
            data-toggle="collapse"
          >
            <span class="text-muted">
              {{ $t("Activity Logs") }}
            </span>
            <i class="fa-regular fa-triangle-exclamation text-danger" />
          </a>
        </div>
      </div>
      <button
        :class="{ 'text-muted': !isClose }"
        @click="close()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2"
      >
        <span>×</span>
      </button>
    </div>
    <div
      v-if="showLogError"
      style="max-width: 320px;"
    >
      <div
        class="collapse"
        id="collapse-icon"
      >
        <div
          v-if="completeList"
          class="card-body border-left-warning border-left-2 pl-0 pt-0"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <ul class="list mb-0">
            <li
              v-for="(list, i) in completeList"
              :key="'list' + i"
              class="font-size-sm mb-2"
              :class="{ 'text-danger': !list.status }"
            >
              <span v-if="list.status">({{ list.productName }}) {{ list.message }}</span>
              <span v-else>({{ list.productName }}) {{ list.message }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Cookies from 'js-cookie'
import Echo from "laravel-echo";
window.Pusher = require("pusher-js");
import WebSocket from "isomorphic-ws";

export default {
  data() {
    return {
      progressBarWidth: 0,
      showLogError: false,
      complete: false,
      isClose: false,
      tenant: JSON.parse(Cookies.get('tenant')),
      user: JSON.parse(Cookies.get('user')),
      websocket: null,
      completeList: [],
    };
  },
  methods: {
    close() {
      this.leaveChannel();
      this.$store.dispatch("product/isProgressBarProduct", { open: false, type: null });
    },
    leaveChannel() {
      const tenant = this.tenant;
      const user = this.user;
      // window.Echo.leave(`products.created.${tenant.id}`);
      // window.Echo.leaveChannel(`products.created.${user.id}${tenant.id}`);
      if (this.websocket) {
        console.log('Off websocket')

        this.websocket.close();
      }
    },
    openChannel() {
      
      const tenant = this.tenant;
      const user = this.user;
      const vm = this;
      var product = this.$store.state.product.isProgressBarProduct.products[0];
      var productList = [];

      if(product.product_type_id == 2){
        let product_variant = [];
        product.product_variant_with_product.forEach(product => {
          product_variant.push(product.product_id);
        });
        product_variant.forEach(element => {
            if (!productList.includes(element)) {
                productList.push(element);
            }
        });
      }else{
          productList.push(product.id);
      }
      console.log(productList);

      if (localStorage.getItem('isCypress')) {
        let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));
          if (dataWebsocket) {
            
            dataWebsocket.forEach(data => {
              let dataOnmessage = JSON.parse(JSON.stringify(data)) 
              this.websocketOnMessage(dataOnmessage ,user, tenant , productList);
            }); 
          }
      } else {
        if (this.$storeIndex.isset(() => tenant.id) && this.$storeIndex.isset(() => user.id)) {

          let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
          // Open websocket
          ws.onopen = function open() {
            console.log('onopen')
            let clientUid = `products.created.${user.id}${tenant.id}`;

            ws.send(JSON.stringify({
              "data": {
                "clientUid": clientUid
              },
              "event": "subscribe"
            }));
          };
          // Action websocket
          ws.onmessage = function incoming(message) {
            let dataOnmessage = JSON.parse(message.data)
            this.websocketOnMessage(dataOnmessage , user ,tenant , productList);
                // console.log('data',data);
          };   
        }
      }
    },

    websocketOnMessage (data, user, tenant , productList) {
      let productType = this.$store.state.product.isProgressBarProduct.type;
      let textAlert = productType == "duplicate-config" || productType == "duplicate-simple" ? "Duplicate Product Success." : "Create Product Success."
      let vm = this;
      let count_product_all = productList.length;

      if (data.data.clientUid == `products.created.${user.id}${tenant.id}` && data.event == `products.created`) {
              let paylaod = data.data;
                productList = productList.filter((id) => {
                  return id != paylaod.productId;
              });
              let count_product = count_product_all - productList.length;
              let progress = (count_product / count_product_all)*100;

              vm.progressBarWidth = progress;
              if(!paylaod.status){
                if (!vm.showLogError) {
                  vm.showLogError = true;
                }
                vm.completeList.unshift({
                  'status': paylaod.status,
                  'productName': paylaod.productName,
                  'message': vm.$t(paylaod.message.split('"').join(''))
                });
              }

              if(progress == 100){
                vm.complete = true;
                if (!vm.showLogError) {
                  setTimeout(() => {vm.close()}, 1000);

                  setTimeout(() => {
                    vm.$toastr.s(vm.$t(textAlert), "<span class='t-icon icon-checkmark3'></span>" + vm.$t("Success"));
                  }, 1000);
                }
              }
            }

    }
  },
  mounted() {
    const host = window.location.host;
    const parts = host.split(".");
    const wsHost = parts[0] + "." + process.env.WEBSOCKETS_URL;
    window.Echo = new Echo({
      broadcaster: "pusher",
      key: process.env.WEBSOCKETS_KEY,
      wsHost: wsHost,
      wsPort: 6001,
      forceTLS: false,
      disableStats: true,
      transports: ["websocket", "polling", "flashsocket"],
      enabledTransports: ["ws", "wss"],
    });

    this.openChannel();

    const thisVue = this;
    window.Echo.connector.pusher.connection.bind('state_change', function(states) {
      const unavailableStates = ["unavailable", "disconnected"];
      if (unavailableStates.includes(states.current)) {
        thisVue.close();
      }
    });
  },
  beforeDestroy() {
    this.close();
  },
  watch: {
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/products/ProgressBarProduct.vue